import React, { lazy, Suspense, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Loading from "../../components/Loading";

const Layout = ({ children, component, content, ...props }) => {
  const LayoutComponent = useMemo(() => lazy(() => import(`./${component}`)), [
    component,
  ]);

  const Content = useSelector((state) => state.content);

  if (!Array.isArray(Content?.data)) return <Loading />;

  return (
    <LayoutComponent content={content || Content} {...props}>
      {children}
    </LayoutComponent>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  component: PropTypes.oneOf([
    // Restructured Components Available
    "LayoutOne",
  ]).isRequired,
  content: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        logo: PropTypes.string,
        name: PropTypes.object,
        contact: PropTypes.array,
        aboutUsLink: PropTypes.array,
        usefulLink: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.object,
            url: PropTypes.string,
          })
        ),
      })
    ),
  }),
  headerContainerClass: PropTypes.string,
  headerTop: PropTypes.string,
  // headerBorderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  // footerBgClass: PropTypes.string,
};

Layout.defaultProps = {
  children: null,
  headerContainerClass: "container-fluid",
  headerTop: "visible",
  // headerBorderStyle: "",
  headerPaddingClass: "header-padding-2",
  // footerBgClass: "bg-gray",
};

export default Layout;
